export function namedListPreview<T>(items: T[], cap: number): { shown: T[]; remaining: number } {
  const shown = items.slice(0, cap);
  const remaining = Math.max(items.length - shown.length, 0);
  return { shown, remaining };
}
